import React, { Component } from "react";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import { Row, Col, Image, FormControl, Form } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Unblock from "../../../assets/images/Unblock.svg";
import Modal from "react-bootstrap/Modal";
import userblock1 from "../../../assets/images/userblock1.svg";
// import "../../../App.scss"
import Loader from "../../common/Loader";
import delivaApiService from "../../../common/services/apiService";
import {
  getLocalStorage,
  range,
  trackGoogleApiCall,
} from "../../../common/helpers/Utils";
import CONSTANTS from "../../../common/helpers/Constants";
import moment from "moment";
import Template from "../../../common/helpers/Template";

class OrderTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      delivery_agent_list: [],
      pageno: 1,
      records: 10,
      totalCount: "",
      sortBy: "",
      sortOrder: "desc",
      keyword: "",
      search: "",
      showInviteVendors: false,
      blockedDueToCancellationLimit: "",
      deliveryStatus: "",
      showFindPartnersModal: false,
      selectedLocation: null,
      locationInput: "",
      selectedRadius: "20",
      suggestions: [],
      nearbyPartners: [],
      findPartnersLoading: false,
    };
    this.mapRef = React.createRef();
    this.googleMapInstance = null;
    this.autocompleteService = null;
    this.markers = [];
    this.activeInfoWindow = null;
  }

  getOrders(pageno, records, sortBy, sortOrder, search) {
    this.setState({
      delivery_agent_list: [],
      // showLoader: true,
      pageno: pageno,
      records: records,
      sortBy: sortBy,
      sortOrder: sortOrder,
      search: search,
    });
    this.setState(
      {
        apiName:
          this.state.pageName == CONSTANTS.ORDERTYPES.TOTAL
            ? "getTotalOrders"
            : this.state.pageName == CONSTANTS.ORDERTYPES.PICKUP
              ? "getPickupOrders"
              : this.state.pageName == CONSTANTS.ORDERTYPES.CANCELLED
                ? "getCancelledOrders"
                : this.state.pageName == CONSTANTS.ORDERTYPES.INTRANSIT
                  ? "getInTransitOrders"
                  : this.state.pageName == CONSTANTS.ORDERTYPES.DELIVERED
                    ? "getCompletedOrders"
                    : "",
      },
      () => {
        this.setLoader(true);
        delivaApiService(this.state.apiName, {
          pageNumber: pageno,
          records: records,
          sortBy: sortBy,
          sortOrder: sortOrder,
          searchKey: this.state.search,
          deliveryStatus: this.state.deliveryStatus,
        })
          .then((response) => {
            this.setLoader(false);
            // if (response && response.data && response.data.resourceData) {
            this.setState(
              {
                delivery_agent_list: response.data.resourceData,
                totalCount: response.data.totalRecords,
              },
              this.getPager(response.data.totalRecords),
            );
            // }
          })
          .catch((err) => {});
      },
    );
  }

  handleInviteVendors = (id, status) => {
    this.setState({
      showInviteVendors: !this.state.showInviteVendors,
      blockId: id,
      blockedStatus: status,
    });
  };

  componentDidMount() {
    this.setState(
      {
        pageName: this.props.match.params.name,
      },
      () => {
        this.getOrders(
          this.state.pageno,
          this.state.records,
          this.state.sortBy,
          this.state.sortOrder,
          this.state.search,
        );
      },
    );
  }

  //manage page counts
  getPager(total) {
    let startPage = this.state.startPage;
    let endPage = this.state.endPage;
    let totalPage = Math.ceil(total / this.state.records);
    let pageno = this.state.pageno;

    if (totalPage <= 5) {
      startPage = 1;
      endPage = totalPage;
    } else {
      if (pageno <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (pageno + 1 >= totalPage) {
        startPage = totalPage - 4;
        endPage = totalPage;
      } else {
        startPage = pageno - 2;
        endPage = pageno + 2;
      }
    }
    let startIndex = (pageno - 1) * this.state.records;
    let endIndex = Math.min(startIndex + this.state.records - 1, totalPage - 1);

    // create an array of pages to ng-repeat in the pager control
    let pageArray;
    if (startPage == endPage) {
      pageArray = [1];
    } else {
      pageArray = range(startPage, endPage);
    }
    this.setState({
      // records: this.state.records,
      totalPage: totalPage,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pageArray: pageArray,
    });
  }

  // change page

  onChangePage(page) {
    if (page == this.state.pageno) {
    } else {
      this.getOrders(
        page,
        this.state.records,
        this.state.sortBy,
        this.state.sortOrder,
        this.state.search,
      );
    }
  }

  //change data per page
  onChangeItemPerPage(e) {
    this.setState({ records: e.target.value });
  }

  onEnterPerPage(e) {
    if (e.key === "Enter") {
      const val = e.target.value;
      if (val && val > 0) {
        this.getOrders(
          1,
          val,
          this.state.sortBy,
          this.state.sortOrder,
          this.state.search,
        );
      }
    }
  }

  handleFilterChange = (e) => {
    this.setState({ deliveryStatus: e.target.value }, () => {
      this.getOrders(
        1,
        this.state.records,
        this.state.sortBy,
        this.state.sortOrder,
        this.state.search,
      );
    });
  };

  handleChangeInput = (e) => {
    let value = e.target.value;
    let trimmedValue = value.replace(/\s+/g, " ").trimStart();
    this.setState({ search: trimmedValue }, () => {
      if (this.state.search.length == 0 && trimmedValue === "") {
        this.getOrders(
          this.state.pageno,
          this.state.records,
          this.state.sortBy,
          this.state.sortOrder,
          this.state.search,
        );
      }
    });
  };

  handleEnter = (e) => {
    if (e.key == "Enter") {
      this.getOrders(
        this.state.pageno,
        this.state.records,
        this.state.sortBy,
        this.state.sortOrder,
        this.state.search,
      );
    }
  };

  handleSearch() {
    if (this.state.search.trim() != "") {
      this.getOrders(
        this.state.pageno,
        this.state.records,
        this.state.sortBy,
        this.state.sortOrder,
        this.state.search,
      );
    }
  }

  sortDeliveryAgent(val) {
    this.setState({ sortOrder: this.state.sortOrder == "desc" ? "" : "desc" });
    if (this.state.sortOrder == "desc") {
      this.getOrders(
        this.state.pageno,
        this.state.records,
        val,
        "asc",
        this.state.search,
      );
    } else {
      this.getOrders(
        this.state.pageno,
        this.state.records,
        val,
        "desc",
        this.state.search,
      );
    }
  }
  setLoader(showLoader) {
    this.setState({
      showLoader,
    });
  }
  handleRouteChange(val) {
    this.props.history.push(val);
  }
  changepath = (path, props) => {
    this.props.history.push(path);
  };
  orderStatus = (status) => {
    if (status === CONSTANTS.ORDER_STATUS.TRANSIT) {
      return "In transit";
    } else if (status === CONSTANTS.ORDER_STATUS.ACCEPTED) {
      return "Accepted";
    } else if (status === CONSTANTS.ORDER_STATUS.DELIVERED) {
      return "Delivered";
    } else if (status == CONSTANTS.ORDER_STATUS.CANCELLED) {
      return "Cancelled";
    } else if (status === CONSTANTS.ORDER_STATUS.REJECTED) {
      return "Pickup rejected";
    }
  };

  // Find Partners Modal Methods
  handleOpenFindPartnersModal = () => {
    this.setState({ showFindPartnersModal: true }, () => {
      setTimeout(() => {
        this.initializeMap();
      }, 100);
    });
  };

  handleCloseFindPartnersModal = () => {
    this.setState({
      showFindPartnersModal: false,
      selectedLocation: null,
      locationInput: "",
      selectedRadius: "20",
      suggestions: [],
      nearbyPartners: [],
      findPartnersLoading: false,
    });
    this.markers.forEach((marker) => marker.setMap(null));
    this.markers = [];
    if (this.activeInfoWindow) {
      this.activeInfoWindow.close();
      this.activeInfoWindow = null;
    }
    // Reset the map instance so it can be re-initialized next time
    this.googleMapInstance = null;
  };

  initializeMap = () => {
    if (!window.google || !this.mapRef.current || this.googleMapInstance)
      return;

    const defaultCenter = { lat: 9.082, lng: 8.6753 };

    this.googleMapInstance = new window.google.maps.Map(this.mapRef.current, {
      center: defaultCenter,
      zoom: 6,
      mapTypeControl: false,
      fullscreenControl: true,
      streetViewControl: false,
    });

    trackGoogleApiCall("MapsJavaScriptAPI");

    if (window.google.maps.places) {
      this.autocompleteService =
        new window.google.maps.places.AutocompleteService();
    }
  };

  handleLocationInputChange = (e) => {
    const value = e.target.value;
    this.setState({ locationInput: value });

    if (value.length > 2 && this.autocompleteService) {
      this.autocompleteService.getPlacePredictions(
        { input: value },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            this.setState({ suggestions: predictions });
            trackGoogleApiCall("PlacesAutocomplete");
          }
        },
      );
    } else {
      this.setState({ suggestions: [] });
    }
  };

  handleSelectLocation = (suggestion) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: suggestion.place_id }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        this.setState({
          selectedLocation: {
            lat: location.lat(),
            lng: location.lng(),
            address: suggestion.description,
          },
          locationInput: suggestion.description,
          suggestions: [],
        });
        trackGoogleApiCall("Geocoding");
      }
    });
  };

  handleRadiusChange = (e) => {
    this.setState({ selectedRadius: e.target.value });
  };

  handleViewAllPartners = () => {
    const { selectedLocation, selectedRadius, nearbyPartners } = this.state;

    const params = new URLSearchParams();
    if (selectedLocation?.address) {
      params.set("location", selectedLocation.address);
      params.set("latitude", selectedLocation.lat);
      params.set("longitude", selectedLocation.lng);
    }
    params.set("range", `${selectedRadius} Km Radius`);
    params.set("radiusKm", selectedRadius);
    params.set("count", nearbyPartners.length);

    this.handleCloseFindPartnersModal();
    this.props.history.push(`/deliveryPartnerList?${params.toString()}`);
  };

  handleFindPartners = () => {
    if (!this.state.selectedLocation || !this.googleMapInstance) return;

    const { lat, lng } = this.state.selectedLocation;
    const radiusKm = parseInt(this.state.selectedRadius);

    this.setState({ findPartnersLoading: true, nearbyPartners: [] }, () => {
      this.markers.forEach((marker) => marker.setMap(null));
      this.markers = [];

      // Store selected location marker reference to add it later (after partner pins)
      let selectedLocationMarker = null;

      const circle = new window.google.maps.Circle({
        strokeColor: "#1A73E8",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#1A73E8",
        fillOpacity: 0.15,
        map: this.googleMapInstance,
        center: { lat, lng },
        radius: radiusKm * 1000,
        clickable: false, // Make circle non-clickable so clicks pass through to map
      });
      this.markers.push(circle);

      this.googleMapInstance.setCenter({ lat, lng });
      const zoomLevel = radiusKm <= 5 ? 12 : radiusKm <= 10 ? 11 : 10;
      this.googleMapInstance.setZoom(zoomLevel);

      // Add click listener to map to close InfoWindow when clicking outside
      window.google.maps.event.addListener(
        this.googleMapInstance,
        "click",
        () => {
          if (this.activeInfoWindow) {
            this.activeInfoWindow.close();
            this.activeInfoWindow = null;
          }
        },
      );

      delivaApiService("getNearbyPartners", {
        latitude: lat,
        longitude: lng,
        radiusKm: radiusKm,
        roleId: 3,
      })
        .then((response) => {
          // Try different possible response structures
          let partners = [];
          if (response && response.data) {
            if (
              response.data.resourceData &&
              response.data.resourceData.partners
            ) {
              partners = response.data.resourceData.partners;
            } else if (
              response.data.resourceData &&
              Array.isArray(response.data.resourceData)
            ) {
              partners = response.data.resourceData;
            } else if (response.data.partners) {
              partners = response.data.partners;
            } else if (Array.isArray(response.data)) {
              partners = response.data;
            }
          }

          this.setState({
            nearbyPartners: partners,
            findPartnersLoading: false,
          });

          // Track used coordinates to handle overlapping markers
          const usedCoordinates = new Map();

          partners.forEach((partner) => {
            let partnerLat = parseFloat(partner.latitude);
            let partnerLng = parseFloat(partner.longitude);
            if (isNaN(partnerLat) || isNaN(partnerLng)) return;

            // Create a key for this coordinate
            const coordKey = `${partnerLat.toFixed(6)},${partnerLng.toFixed(6)}`;

            // If this coordinate is already used, add a small offset
            if (usedCoordinates.has(coordKey)) {
              const count = usedCoordinates.get(coordKey);
              // Add a small offset based on count (in degrees, roughly 10-20 meters)
              const offsetAmount = 0.0001 * count;
              const angle = count * 45 * (Math.PI / 180); // Spread in different directions
              partnerLat += offsetAmount * Math.cos(angle);
              partnerLng += offsetAmount * Math.sin(angle);
              usedCoordinates.set(coordKey, count + 1);
            } else {
              usedCoordinates.set(coordKey, 1);
            }

            const marker = new window.google.maps.Marker({
              position: { lat: partnerLat, lng: partnerLng },
              map: this.googleMapInstance,
              title: partner.name,
              icon: {
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="48" viewBox="0 0 24 32">
                    <path d="M12,2C8.13,2,5,5.13,5,9c0,5.25,7,13,7,13s7-7.75,7-13C19,5.13,15.87,2,12,2z" fill="#fec32d" stroke="#ffffff" stroke-width="1"/>
                    <circle cx="12" cy="9" r="2.5" fill="#085133" stroke="#ffffff" stroke-width="0.5"/>
                  </svg>
                `),
                scaledSize: new window.google.maps.Size(36, 48),
                anchor: new window.google.maps.Point(18, 44),
              },
            });

            const infoContent = `
              <div style="padding: 0 14px 14px 14px; width: fit-content; font-family: 'Inter', sans-serif; line-height: 1.4;">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
                  <img src="${require("../../../assets/images/UserCircle.svg")}" alt="user" style="width: 18px; height: 18px; flex-shrink: 0;" />
                  <span style="font-weight: 500; font-size: 16px; color: #085133; overflow: hidden; text-overflow: ellipsis; line-height: 1.3;">
                    ${partner.name || "N/A"}
                  </span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                  <img src="${require("../../../assets/images/PhoneCall.svg")}" alt="phone" style="width: 16px; height: 16px; flex-shrink: 0;" />
                  <span style="font-size: 14px; color: #666; line-height: 1.3;">
                    ${partner.mobile ? `+${partner.countryCode || ""} ${partner.mobile}` : partner.formattedMobile || "N/A"}
                  </span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                  <img src="${require("../../../assets/images/Path.svg")}" alt="distance" style="width: 16px; height: 16px; flex-shrink: 0;" />
                  <span style="font-size: 14px; color: #666; line-height: 1.3;">
                    ${partner.distanceLabel || "N/A"}
                  </span>
                </div>
                ${partner.vehicles && partner.vehicles.length > 0 ? `
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <img src="${require("../../../assets/images/steering-wheel.svg")}" alt="vehicle" style="width: 16px; height: 16px; flex-shrink: 0;" />
                    <span style="font-size: 14px; color: #666; line-height: 1.3;">
                      ${partner.vehicles[0].vehicleType === "NONE_OR_ANY_VEHICLE" ? "Any Vehicle" : (partner.vehicles[0].vehicleTypeLabel || "N/A")}
                    </span>
                  </div>
                ` : ''}
              </div>
            `;

            marker.addListener("click", () => {
              // Toggle behavior: close if clicking the same marker
              if (
                this.activeInfoWindow &&
                this.activeInfoWindow.getAnchor() === marker
              ) {
                this.activeInfoWindow.close();
                this.activeInfoWindow = null;
                return;
              }

              // Close existing InfoWindow completely
              if (this.activeInfoWindow) {
                this.activeInfoWindow.close();
                this.activeInfoWindow = null;
              }

              // Small delay to ensure previous InfoWindow is fully removed
              setTimeout(() => {
                this.activeInfoWindow = new window.google.maps.InfoWindow({
                  content: infoContent,
                  disableAutoPan: false,
                  maxWidth: 320,
                });

                // Add domready event listener to hide close button immediately when InfoWindow is rendered
                window.google.maps.event.addListenerOnce(
                  this.activeInfoWindow,
                  "domready",
                  () => {
                    // Remove any duplicate or shadow InfoWindows
                    const allInfoWindows =
                      document.querySelectorAll(".gm-style-iw-c");
                    if (allInfoWindows.length > 1) {
                      // Remove all except the last one (the current one)
                      for (let i = 0; i < allInfoWindows.length - 1; i++) {
                        const parent = allInfoWindows[i].parentElement;
                        if (parent && parent.parentElement) {
                          parent.parentElement.removeChild(parent);
                        }
                      }
                    }
                  },
                );

                // Open the InfoWindow
                this.activeInfoWindow.open(this.googleMapInstance, marker);
              }, 50);
            });

            this.markers.push(marker);
          });

          // Check if any partner is at the exact same location as selected location
          let selectedLat = lat;
          let selectedLng = lng;
          const hasPartnerAtSameLocation = partners.some(partner => {
            const pLat = parseFloat(partner.latitude);
            const pLng = parseFloat(partner.longitude);
            return Math.abs(pLat - lat) < 0.00001 && Math.abs(pLng - lng) < 0.00001;
          });

          // If partner exists at same location, offset the red pin slightly to the side
          if (hasPartnerAtSameLocation) {
            selectedLat += 0.0002; // Offset ~20 meters to the right
          }

          // Add selected location marker AFTER all partner markers so it appears on top
          const selectedMarker = new window.google.maps.Marker({
            position: { lat: selectedLat, lng: selectedLng },
            map: this.googleMapInstance,
            title: "Selected Location",
            icon: {
              path: "M12,2C8.13,2,5,5.13,5,9c0,5.25,7,13,7,13s7-7.75,7-13C19,5.13,15.87,2,12,2z M12,11.5c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5S13.38,11.5,12,11.5z",
              fillColor: "#DC3545",
              fillOpacity: 1,
              strokeColor: "#ffffff",
              strokeWeight: 1,
              scale: 1.5,
              anchor: new window.google.maps.Point(12, 22),
            },
            zIndex: 9999, // Ensure it's always on top
          });
          this.markers.push(selectedMarker);
        })
        .catch(() => {
          this.setState({ findPartnersLoading: false });
        });
    });
  };

  render() {
    const { delivery_agent_list } = this.state;
    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />
        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper">
                  <Row noGutters className="mb-3">
                    <Col md={6} lg={7} className="">
                      <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24 fs22">
                        {this.state.pageName == CONSTANTS.ORDERTYPES.TOTAL
                          ? Template.TOTALORDERS
                          : this.state.pageName ==
                              CONSTANTS.ORDERTYPES.CANCELLED
                            ? "Cancelled Orders"
                            : CONSTANTS.ORDERTYPES.PICKUP == this.state.pageName
                              ? "Accepted Orders"
                              : this.state.pageName ==
                                  CONSTANTS.ORDERTYPES.INTRANSIT
                                ? "In-Transit Orders"
                                : this.state.pageName ==
                                    CONSTANTS.ORDERTYPES.DELIVERED
                                  ? Template.COMPLETEDORDERS
                                  : ""}
                        <span className="color-grey">
                          ({this.state.totalCount})
                        </span>
                      </h3>
                      <h5 className="font-weight-normal mb-0 line-ht fs18 color-head">
                        <span
                          className="pointer"
                          onClick={() => this.handleRouteChange("/dashboard")}
                        >
                          Dashboard
                        </span>

                        <span className="icon-next mx-2 Fs12"></span>
                        {this.state.pageName == CONSTANTS.ORDERTYPES.TOTAL
                          ? Template.TOTALORDERS
                          : this.state.pageName ==
                              CONSTANTS.ORDERTYPES.CANCELLED
                            ? "Cancelled Orders"
                            : CONSTANTS.ORDERTYPES.PICKUP == this.state.pageName
                              ? "Accepted Orders"
                              : this.state.pageName ==
                                  CONSTANTS.ORDERTYPES.INTRANSIT
                                ? "In-transit Orders"
                                : this.state.pageName ==
                                    CONSTANTS.ORDERTYPES.DELIVERED
                                  ? Template.COMPLETEDORDERS
                                  : ""}
                      </h5>
                    </Col>
                    <Col md={6} lg={5} className="text-right">
                      <div
                        className="d-flex align-items-center justify-content-end"
                        style={{ gap: "12px" }}
                      >
                        <div className="form-group mb-0 position-relative w-100">
                          <input
                            name="searchInput"
                            value={this.state.search || ""}
                            onChange={this.handleChangeInput}
                            onKeyDown={this.handleEnter.bind(this)}
                            label="Search"
                            type="text"
                            // placeholder={this.state.pageName!=='cancelled' ? "Search by Order ID, OPC, DPC":"Search by Order ID, Order date"}
                            placeholder={"Search by Order ID, Sender Name"}
                            className="searchTxt w-100"
                          />
                          <span
                            onClick={() => this.handleSearch()}
                            className="icon-search"
                          ></span>
                        </div>
                        {this.state.pageName === CONSTANTS.ORDERTYPES.TOTAL ? (
                          <>
                            <Form.Group className="mb-0">
                              <Form.Control
                                className="login-input select-rounded text-capitalize custom-select"
                                as="select"
                                custom
                                value={this.state.deliveryStatus}
                                onChange={this.handleFilterChange}
                              >
                                <option value="">All Status</option>
                                <option
                                  value={CONSTANTS.ORDER_STATUS.DELIVERED}
                                >
                                  Delivered
                                </option>
                                <option value={CONSTANTS.ORDER_STATUS.TRANSIT}>
                                  In-transit
                                </option>
                                <option value={CONSTANTS.ORDER_STATUS.ACCEPTED}>
                                  Accepted
                                </option>
                                <option
                                  value={CONSTANTS.ORDER_STATUS.CANCELLED}
                                >
                                  Cancelled
                                </option>
                              </Form.Control>
                            </Form.Group>
                            <button
                              className="button rounded-pill btnDefault btnOutline text-nowrap px-4"
                              onClick={this.handleOpenFindPartnersModal}
                            >
                              Find Partners
                            </button>
                          </>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="table-wrap statistics-table">
                        <Table className="inTransitOrderTable">
                          <thead>
                            <tr>
                              <th>
                                Order ID{" "}
                                <a
                                  href="#"
                                  onClick={() =>
                                    this.sortDeliveryAgent("orderId")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </th>
                              <th>
                                Order Date{" "}
                                <a
                                  href="#"
                                  onClick={() =>
                                    this.sortDeliveryAgent("orderDate")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </th>

                              {this.state.pageName !==
                              CONSTANTS.ORDERTYPES.CANCELLED ? (
                                <th>
                                  Pickup{" "}
                                  <a
                                    href="#"
                                    onClick={() =>
                                      this.sortDeliveryAgent("pickUpLocation")
                                    }
                                    className="icon-up-and-down color-light-grey"
                                  ></a>
                                </th>
                              ) : null}
                              {this.state.pageName !==
                              CONSTANTS.ORDERTYPES.CANCELLED ? (
                                <th>
                                  Drop-Off{" "}
                                  <a
                                    href="#"
                                    onClick={() =>
                                      this.sortDeliveryAgent(
                                        "destinationLocation",
                                      )
                                    }
                                    className="icon-up-and-down color-light-grey"
                                  ></a>
                                </th>
                              ) : null}
                              <th>
                                Sender{" "}
                                <a
                                  href="#"
                                  onClick={() =>
                                    this.sortDeliveryAgent("customerName")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </th>

                              <th>
                                Delivery Partner{" "}
                                <a
                                  href="#"
                                  onClick={() =>
                                    this.sortDeliveryAgent("deliveryAgentName")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </th>
                              {this.state.pageName ==
                              CONSTANTS.ORDERTYPES.TOTAL ? (
                                <th>Status </th>
                              ) : null}
                              {this.state.pageName !==
                              CONSTANTS.ORDERTYPES.TOTAL ? (
                                <th>
                                  Receiver{" "}
                                  <a
                                    href="#"
                                    onClick={() =>
                                      this.sortDeliveryAgent("receiverName")
                                    }
                                    className="icon-up-and-down color-light-grey"
                                  ></a>
                                </th>
                              ) : null}
                              {this.state.pageName ==
                              CONSTANTS.ORDERTYPES.PICKUP ? (
                                <th>Pickup Code </th>
                              ) : null}
                              {this.state.pageName ==
                              CONSTANTS.ORDERTYPES.INTRANSIT ? (
                                <th>Drop-Off Code </th>
                              ) : null}
                              <th>Action </th>
                            </tr>
                          </thead>
                          <tbody className="ttl-order-table">
                            {!this.state?.delivery_agent_list?.length ? (
                              <tr>
                                <td colSpan={9} style={{ textAlign: "center" }}>
                                  No Records Available
                                </td>
                              </tr>
                            ) : (
                              this.state?.delivery_agent_list?.map(
                                (item, i) => {
                                  return (
                                    <tr key={Math.random()}>
                                      <td>
                                        <div>
                                          <div>#{item.orderId}</div>
                                          {item.isBundle && (
                                            <span className="bundle-badge">
                                              BUNDLE
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        {moment(item.orderDate).format(
                                          "DD MMM YYYY",
                                        )}
                                      </td>
                                      {this.state.pageName !==
                                      CONSTANTS.ORDERTYPES.CANCELLED ? (
                                        <td>{item.pickUpLocation}</td>
                                      ) : null}
                                      {this.state.pageName !==
                                      CONSTANTS.ORDERTYPES.CANCELLED ? (
                                        <td>
                                          {item.destinationLocation}
                                          {item.dropOffCount > 0 ? (
                                            <span className="drop-off-count">
                                              +{item.dropOffCount}
                                            </span>
                                          ) : null}
                                        </td>
                                      ) : null}
                                      <td className="text-capitalize">
                                        {item.customerName}
                                      </td>
                                      <td className="text-capitalize">
                                        {item.deliveryAgentName}
                                      </td>
                                      {this.state.pageName ==
                                      CONSTANTS.ORDERTYPES.TOTAL ? (
                                        <td
                                          className={
                                            this.orderStatus(item.status) ===
                                            "Delivered"
                                              ? "text-green"
                                              : this.orderStatus(
                                                    item.status,
                                                  ) === "In transit"
                                                ? "text-orange"
                                                : this.orderStatus(
                                                      item.status,
                                                    ) === "Accepted"
                                                  ? "text-blue"
                                                  : "text-red"
                                          }
                                        >
                                          {this.orderStatus(item.status)}
                                        </td>
                                      ) : null}
                                      {this.state.pageName !==
                                      CONSTANTS.ORDERTYPES.TOTAL ? (
                                        <td className="text-capitalize">
                                          {item.receiverName}
                                        </td>
                                      ) : null}
                                      {this.state.pageName ==
                                      CONSTANTS.ORDERTYPES.PICKUP ? (
                                        <td>{item.pickupCode}</td>
                                      ) : null}
                                      {this.state.pageName ==
                                      CONSTANTS.ORDERTYPES.INTRANSIT ? (
                                        <td>{item.dropOffCode}</td>
                                      ) : null}
                                      <td className="views-icos">
                                        <a
                                          className="pointer"
                                          onClick={() =>
                                            this.changepath(
                                              "/" +
                                                this.state.pageName +
                                                "/details/" +
                                                item.orderId,
                                            )
                                          }
                                        >
                                          <span
                                            title="View"
                                            className="icon-eye"
                                          ></span>{" "}
                                          {/* View */}
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                },
                              )
                            )}
                          </tbody>
                        </Table>
                      </div>
                      {this.state?.delivery_agent_list?.length ? (
                        <nav aria-label="Page navigation">
                          <ul className="pagination pg-blue deliva-pagination justify-content-end">
                            <li className="page-item">
                              <button
                                className="page-link rotate-180 control-btn"
                                aria-label="Previous"
                                onClick={() =>
                                  this.onChangePage(this.state.pageno - 1)
                                }
                                disabled={
                                  this.state.pageno == 1 ||
                                  this.state.totalPage == 0
                                }
                              >
                                <span className="icon-next"></span>
                                <span
                                  //className="prevNext"
                                  className={`sr-only ${
                                    this.state.pageno == 1 ||
                                    this.state.totalPage == 0
                                      ? ""
                                      : "active"
                                  }`}
                                >
                                  Previous
                                </span>
                              </button>
                            </li>

                            {this.state.totalPage > 0 &&
                              this.state.pageArray.map((page, ind) => {
                                return (
                                  <li className="page-item" key={Math.random()}>
                                    {/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                    <a
                                      className={`page-link ${
                                        this.state.pageno == page
                                          ? "active"
                                          : ""
                                      }`}
                                      onClick={() => this.onChangePage(page)}
                                    >
                                      {page}
                                    </a>
                                  </li>
                                );
                              })}

                            <li className="page-item">
                              <button
                                className="page-link control-btn"
                                aria-label="Next"
                                onClick={() =>
                                  this.onChangePage(this.state.pageno + 1)
                                }
                                disabled={
                                  this.state.pageno == this.state.totalPage ||
                                  this.state.totalPage == 0
                                }
                              >
                                <span className="icon-next"></span>
                                <span
                                  className={`sr-only ${
                                    this.state.pageno == this.state.totalPage ||
                                    this.state.totalPage == 0
                                      ? ""
                                      : "active"
                                  }`}
                                >
                                  Next
                                </span>
                              </button>
                            </li>

                            <li className="page-value">
                              Enter Per Page{" "}
                              <input
                                type="text"
                                placeholder={CONSTANTS.SHOWRECORDS.NOOFRECORDS}
                                name="records"
                                value={this.state.records}
                                onChange={(e) => this.onChangeItemPerPage(e)}
                                onKeyDown={(e) => this.onEnterPerPage(e)}
                              />
                            </li>
                          </ul>
                        </nav>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <Footer {...this.props} />
            </Col>
          </Row>
        </div>

        {/* Find Partners Modal */}
        <Modal
          show={this.state.showFindPartnersModal}
          onHide={this.handleCloseFindPartnersModal}
          size="lg"
          centered
          className="find-partners-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title className="tertiary-color fs-24 font-weight-normal">
              Find Partners
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-3 px-4 pb-4">
            <div className="modal-content-wrap p-0">
              {/* Search + Filter + Find row */}
              <div
                className="d-flex align-items-end flex-wrap mb-3"
                style={{ gap: "12px" }}
              >
                <div className="flex-grow-1" style={{ minWidth: "180px" }}>
                  <Form.Group className="mb-0">
                    <Form.Label className="color-grey mb-1">
                      Location Name
                    </Form.Label>
                    <div className="position-relative">
                      <FormControl
                        type="text"
                        placeholder="Search location..."
                        className="login-input"
                        value={this.state.locationInput}
                        onChange={this.handleLocationInputChange}
                      />
                      {this.state.suggestions.length > 0 && (
                        <ul
                          className="listData list-unstyled border bg-white position-absolute w-100"
                          style={{
                            zIndex: 1000,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }}
                        >
                          {this.state.suggestions.map((suggestion) => (
                            <li
                              key={suggestion.place_id}
                              className="px-3 py-2 cursor-pointer border-bottom"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.handleSelectLocation(suggestion)
                              }
                            >
                              {suggestion.description}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </Form.Group>
                </div>
                <div style={{ minWidth: "160px" }}>
                  <Form.Group className="mb-0">
                    <Form.Label className="color-grey mb-1">
                      Distance Range (Radius)
                    </Form.Label>
                    <Form.Control
                      as="select"
                      className="login-input text-capitalize custom-select"
                      value={this.state.selectedRadius}
                      onChange={this.handleRadiusChange}
                    >
                      <option value="5">5 km</option>
                      <option value="10">10 km</option>
                      <option value="20">20 km</option>
                      <option value="50">50 km</option>
                    </Form.Control>
                  </Form.Group>
                </div>
                <button
                  className="b1-btn"
                  onClick={this.handleFindPartners}
                  disabled={
                    !this.state.selectedLocation ||
                    this.state.findPartnersLoading
                  }
                >
                  {this.state.findPartnersLoading ? "Finding..." : "Find"}
                </button>
              </div>

              {/* Results Summary */}
              {this.state.selectedLocation && (
                <div className="d-flex justify-content-between align-items-center mb-3 px-1">
                  <span className="fs20 tertiary-color font-weight-normal">
                    Total Partners{" "}
                    <span className="tertiary-color">
                      (
                      {this.state.findPartnersLoading
                        ? "..."
                        : this.state.nearbyPartners.length}
                      )
                    </span>
                  </span>
                  {this.state.nearbyPartners.length > 0 &&
                    !this.state.findPartnersLoading && (
                      <a
                        className="find-partners-view-all font-weight-normal text-underline pointer"
                        onClick={this.handleViewAllPartners}
                      >
                        View all partners
                      </a>
                    )}
                </div>
              )}

              {/* Map View */}
              <div
                className="map-container mb-3"
                style={{
                  height: "400px",
                  width: "100%",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  position: "relative",
                }}
              >
                <div
                  ref={this.mapRef}
                  style={{ height: "100%", width: "100%" }}
                ></div>
                {this.state.findPartnersLoading && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(255,255,255,0.7)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 10,
                    }}
                  >
                    <span style={{ color: "#333", fontSize: "14px" }}>
                      Searching for nearby partners...
                    </span>
                  </div>
                )}
              </div>

              {this.state.selectedLocation &&
                !this.state.findPartnersLoading &&
                this.state.nearbyPartners.length === 0 && (
                  <div
                    className="mb-3 text-center"
                    style={{ color: "#999", fontSize: "14px" }}
                  >
                    No partners found within the selected radius.
                  </div>
                )}
            </div>
          </Modal.Body>
        </Modal>

        <Loader showLoader={this.state.showLoader} />
      </div>
    );
  }
}
export default OrderTypes;
